module.exports = __webpack_public_path__ + "img/wait.6b79342c.png";